/**
 * Centralized file URL builder
 *
 * Constructs absolute URLs for static files stored in /uploads
 * Supports Cloudinary URLs directly
 *
 * Rules:
 * - If file is Cloudinary (is_cloudinary_file=true), use cloudinary_url directly
 * - If file_path starts with /uploads/, build URL as API_URL + /uploads + path
 * - API_URL already includes /api, so result is: {API_URL}/uploads/{path}
 * - Falls back to localhost:5000/api for development
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export function buildFileUrl(file) {
  if (!file) {
    return null;
  }

  // If file is a string, treat it as filePath (legacy behavior)
  if (typeof file === 'string') {
    if (file.startsWith('/uploads/')) {
      return `${API_URL}${file}`;
    }
    if (file.startsWith('http://') || file.startsWith('https://')) {
      return file;
    }
    return `${API_URL}/${file}`;
  }

  // Handle Cloudinary files (full file object)
  if (file.is_cloudinary_file && file.cloudinary_url) {
    return file.cloudinary_url;
  }

  // Handle Google Drive files (full file object)
  if (file.is_drive_file && file.drive_web_view_link) {
    return file.drive_web_view_link;
  }

  const filePath = file.file_path;

  if (!filePath) {
    return null;
  }

  if (filePath.startsWith('/uploads/')) {
    return `${API_URL}${filePath}`;
  }

  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }

  return `${API_URL}/${filePath}`;
}

export function isStaticFileUrl(url) {
  return url?.startsWith('/uploads/') || 
         url?.startsWith('http://') || 
         url?.startsWith('https://');
}
